// extracted by mini-css-extract-plugin
export default {"leftSideWrapper":"QeqKlZ","center":"Pmc9Sf","backBtn":"DWms_v"};